import React from 'react';
import { Box } from '@mui/material';
import LogoEdilSystem from '../../assets/full-color-logo.svg';

const FooterTelaLogin: React.FC = () => {
  const handleClick = () => {
    window.open('https://www.edilsystem.com.br', '_blank');
  };

  return (
    <Box
      component="footer"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      mt={2}
      sx={{
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        cursor: 'pointer'
      }}
      onClick={handleClick}
    >
      <Box component="img" src={LogoEdilSystem} alt="Logo Edil System" width={120} />
    </Box>
  );
};

export default FooterTelaLogin;
